import React, { Fragment } from "react";

const PreciosSection = (props) => {
  const {
    producto = {},
    totalSeguroCancelacion,
    totalRegimen,
    intereses,
    totalCompra
  } = props;
  const { precioAlojamiento, precioSinIva, gastoDeReserva } = producto;
  return (
    <Fragment>
      <ul className="info form-row">
        <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
          Alojamiento
        </li>
        <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
          $ {precioSinIva}
        </li>
        <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Regimen</li>
        <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
          $ {totalRegimen}
        </li>
        <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
          Gastos de Reserva
        </li>
        <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
          $ {gastoDeReserva}
        </li>
        <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">Impuestos</li>
        <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
          $ {Math.ceil(precioAlojamiento - precioSinIva)}
        </li>
        {totalSeguroCancelacion > 0 && (
          <Fragment>
            <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
              Seguro de Cancelaci&oacute;n
            </li>
            <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
              $ {totalSeguroCancelacion.toLocaleString()}
            </li>
          </Fragment>
        )}
        {intereses > 0 && (
          <Fragment>
            <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
              Intereses
            </li>
            <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 precio">
              $ {intereses}
            </li>
          </Fragment>
        )}
      </ul>
      <div className="total row">
        <h3 className="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7">Total</h3>
        <h2 className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5">
          $ {totalCompra + intereses}
        </h2>
      </div>
    </Fragment>
  );
};

export default PreciosSection;



// WEBPACK FOOTER //
// ./src/components/Hoteles/ProcesoCompraCdr/FichaReservaCdr/preciosSection.js